<template>
  <div>
    <div class="dots dots1"></div>
    <div class="dots dots2"></div>
  </div>
</template>

<style lang="scss">
.dots:before,
.dots:after {
  content: "";
  position: fixed;
  top: 0;
  bottom: 0;
  opacity: 0.5;
  z-index: 11;
  background-image: linear-gradient(var(--tertiary-color) 20%, transparent 0);
  background-size: 100% var(--dots-gap);
  background-position: 0 0;
  -webkit-animation: movebg 0.2s linear infinite;
  animation: movebg 0.2s linear infinite;
  will-change: transform;
  width: 2px;
}

.dots1:before {
  left: 5%;
}

.dots1:after {
  left: 15%;
}

.dots2:before {
  right: 75%;
}

.dots2:after {
  right: 5%;
}

.dots:after {
  animation-direction: reverse;
}

@-webkit-keyframes movebg {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, var(--dots-gap), 0);
  }
}

@keyframes movebg {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, var(--dots-gap), 0);
  }
}

/* Adaptives */
@media only screen and (max-width: 64em) {
  .dots1:before {
    left: 2%;
  }
  .dots1:after {
    display: none;
  }

  .dots2:before {
    display: none;
  }
}
@media only screen and (min-width: 64em) {
}
/* End Adaptives */
</style>
